import { Chip } from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import RateReviewRoundedIcon from "@mui/icons-material/RateReviewRounded";
import { ToolsRunStatus } from "../../../interfaces/interfaces";

const statusConfig = {
  matched: { label: "Matched", color: "#237A57", bg: "#E7F5EE", icon: <CheckCircleRoundedIcon /> },
  needs_review: { label: "Needs review", color: "#9A6200", bg: "#FFF3D8", icon: <RateReviewRoundedIcon /> },
  error: { label: "Error", color: "#B43A3A", bg: "#FDEAEA", icon: <ErrorOutlineRoundedIcon /> },
};

export const ToolsRunStatusBadge = ({ status }: { status: ToolsRunStatus }) => {
  const config = statusConfig[status];
  return (
    <Chip
      size="small"
      icon={config.icon}
      label={config.label}
      sx={{
        height: 27,
        bgcolor: config.bg,
        color: config.color,
        border: `1px solid ${config.color}22`,
        fontWeight: 700,
        fontSize: 11,
        "& .MuiChip-icon": { color: config.color, fontSize: 16 },
      }}
    />
  );
};
